'use client';

import MagicJump from '@/components/MagicJump';
import { useInViewportAnimation } from '@/hooks/useInViewportAnimation'; // 导入动画hook
import styles from './common.module.scss';

interface Part5Item {
  img_url: string;
  content: string;
  jump_target?: any;
}

interface Part5Data {
  title: string;
  list: Part5Item[];
}

interface Part5Props {
  data: Part5Data | null;
  isMobile: boolean;
}

export default function Part5({ data, isMobile }: Part5Props) {
  // 动画hook，仅PC端执行
  const animationRef = useInViewportAnimation(
    () => {
      if (isMobile) return;
      try {
        // 标题动画
        const title = document.getElementsByClassName('fit-guide-container-section-part5-title');
        if (title[0]) {
          title[0].classList.add('fadeInDownAnimate');
        }
        // 卡片动画
        const cards = document.getElementsByClassName('fit-guide-container-section-part5-card');
        Array.from(cards).forEach((item, idx) => {
          setTimeout(() => {
            item.classList.add('activityFadeInUpAnimate');
          }, idx * 150);
        });
      } catch {
        // 出错时直接显示
        const elements = document.querySelectorAll('.opacity0');
        elements.forEach((el) => {
          const element = el as HTMLElement; // 创建一个新的变量
          element.style.opacity = '1'; // 修改新变量的属性
        });
      }
    },
    { threshold: 0.3, once: true },
  );
  if (!data || !data.list?.length) {
    return null;
  }

  return (
    <div
      ref={(node) => {
        // 为动画设置ref（仅PC端）
        if (!isMobile && animationRef && typeof animationRef !== 'function') {
          (animationRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
        }
      }}
      className="fit-guide-container-section-part5 px-[22px] py-[40px] md:pt-[5vw] md:px-[9.79vw] md:pb-[6.3vw]"
      style={{ fontFamily: 'var(--font-bricolage-bold)' }}
    >
      <h3
        className={`fit-guide-container-section-part5-title ${styles.section_title} ${isMobile ? styles['max-line-2'] : styles['max-line-1']} ${!isMobile ? 'opacity0' : ''}`}
        dangerouslySetInnerHTML={{ __html: data.title }}
      />

      <div className="mt-[24px] grid grid-cols-2 gap-y-[35px] gap-x-[12px] md:mt-[2.08vw] md:grid-cols-4 md:gap-[3.33vw]">
        {data.list.map((item, index) => (
          <div
            key={index}
            className={`fit-guide-container-section-part5-card ${!isMobile ? 'opacity0' : ''}`}
          >
            <MagicJump
              prefetch={false}
              item={item.jump_target}
              className="flex flex-col justify-between items-center no-underline"
            >
              <img
                src={item.img_url}
                alt={item.content}
                className="w-[160px] h-auto mb-[9px] block md:w-full md:mb-[2.81vw]"
              />
              <h4
                className={`mt-7 text-base text-[16px] md:text-[1.23vw] leading-5 leading-[20px] md:leading-7 font-bricolage-bold font-normal text-center ${isMobile ? styles['max-line-2'] : ''}`}
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            </MagicJump>
          </div>
        ))}
      </div>
    </div>
  );
}
